module.exports = __webpack_public_path__ + "img/die-1.23c13853.png";